import React from "react";

interface ICollectionCardForegroundIconProps {
  variant?: number | null;
}

export default function CollectionCardForegroundIcon({ variant }: ICollectionCardForegroundIconProps) {
  if (variant === 1) {
    return (
      <svg width="226px" height="61" viewBox="0 0 226 61" fill="none">
        <line x1="-75.1303" y1="1.82283" x2="229.681" y2="-64.1108" stroke="currentColor" />
        <line x1="-74.4679" y1="4.88581" x2="230.344" y2="-61.0479" stroke="currentColor" />
        <line x1="-73.8051" y1="7.9488" x2="231.006" y2="-57.9849" stroke="currentColor" />
        <line x1="-73.1427" y1="11.0118" x2="231.669" y2="-54.9219" stroke="currentColor" />
        <line x1="-72.4803" y1="14.0743" x2="232.331" y2="-51.8594" stroke="currentColor" />
        <line x1="-71.8174" y1="17.1373" x2="232.994" y2="-48.7964" stroke="currentColor" />
        <line x1="-71.1551" y1="20.2003" x2="233.656" y2="-45.7334" stroke="currentColor" />
        <line x1="-70.4927" y1="23.2633" x2="234.319" y2="-42.6704" stroke="currentColor" />
        <line x1="-69.8298" y1="26.3262" x2="234.982" y2="-39.6074" stroke="currentColor" />
        <line x1="-69.1675" y1="29.3892" x2="235.644" y2="-36.5444" stroke="currentColor" />
        <line x1="-68.5046" y1="32.4522" x2="236.307" y2="-33.4814" stroke="currentColor" />
        <line x1="-67.8422" y1="35.5147" x2="236.969" y2="-30.4189" stroke="currentColor" />
        <line x1="-67.1799" y1="38.5777" x2="237.632" y2="-27.356" stroke="currentColor" />
        <line x1="-66.517" y1="41.6407" x2="238.294" y2="-24.293" stroke="currentColor" />
        <line x1="-65.8546" y1="44.7037" x2="238.957" y2="-21.23" stroke="currentColor" />
        <line x1="-65.1923" y1="47.7667" x2="239.619" y2="-18.167" stroke="currentColor" />
        <line x1="-64.5294" y1="50.8297" x2="240.282" y2="-15.104" stroke="currentColor" />
        <line x1="-63.8671" y1="53.8927" x2="240.944" y2="-12.041" stroke="currentColor" />
        <line x1="-63.2046" y1="56.9556" x2="241.607" y2="-8.97803" stroke="currentColor" />
        <line x1="-62.5418" y1="60.0181" x2="242.27" y2="-5.91553" stroke="currentColor" />
        <path d="M58 -1L-15 50V-1H58Z" fill="currentColor" />
      </svg>
    );
  }

  if (variant === 2) {
    return (
      <svg width="73px" height="82" viewBox="0 0 73 82" fill="none">
        <path d="M72.5 -1L0 82V-1H72.5Z" fill="currentColor" />
      </svg>
    );
  }

  if (variant === 3) {
    return (
      <svg width="226px" height="97" viewBox="0 0 226 97" fill="none">
        <line x1="-83.7228" y1="0.181728" x2="220.774" y2="-67.1891" stroke="currentColor" />
        <line x1="-83.0459" y1="3.2413" x2="221.451" y2="-64.1296" stroke="currentColor" />
        <line x1="-82.3691" y1="6.30087" x2="222.128" y2="-61.07" stroke="currentColor" />
        <line x1="-81.6918" y1="9.36093" x2="222.805" y2="-58.01" stroke="currentColor" />
        <line x1="-81.015" y1="12.4205" x2="223.482" y2="-54.9504" stroke="currentColor" />
        <line x1="-80.3382" y1="15.4806" x2="224.159" y2="-51.8903" stroke="currentColor" />
        <line x1="-79.6609" y1="18.5401" x2="224.836" y2="-48.8308" stroke="currentColor" />
        <line x1="-78.9841" y1="21.5997" x2="225.513" y2="-45.7712" stroke="currentColor" />
        <line x1="-78.3073" y1="24.6598" x2="226.19" y2="-42.7111" stroke="currentColor" />
        <line x1="-77.63" y1="27.7193" x2="226.867" y2="-39.6516" stroke="currentColor" />
        <line x1="-76.9532" y1="30.7794" x2="227.544" y2="-36.5915" stroke="currentColor" />
        <line x1="-76.2759" y1="33.839" x2="228.221" y2="-33.5319" stroke="currentColor" />
        <line x1="-75.599" y1="36.8985" x2="228.898" y2="-30.4724" stroke="currentColor" />
        <line x1="-74.9222" y1="39.9586" x2="229.575" y2="-27.4123" stroke="currentColor" />
        <line x1="-74.2449" y1="43.0182" x2="230.252" y2="-24.3527" stroke="currentColor" />
        <line x1="-73.5681" y1="46.0782" x2="230.929" y2="-21.2927" stroke="currentColor" />
        <line x1="-72.8913" y1="49.1378" x2="231.606" y2="-18.2331" stroke="currentColor" />
        <line x1="-72.214" y1="52.1974" x2="232.283" y2="-15.1735" stroke="currentColor" />
        <line x1="-71.5372" y1="55.2574" x2="232.96" y2="-12.1135" stroke="currentColor" />
        <line x1="-70.8604" y1="58.317" x2="233.637" y2="-9.0539" stroke="currentColor" />
        <line x1="-70.183" y1="61.377" x2="234.314" y2="-5.99384" stroke="currentColor" />
        <path d="M-22.6388 23.721L146.237 -1.65949L57.4482 -74.2446L-22.6388 23.721Z" fill="currentColor" />
      </svg>
    );
  }

  return (
    <svg width="226px" height="75px" viewBox="0 0 226 75" fill="none">
      <line x1="-131.443" y1="0.507884" x2="173.368" y2="-65.4258" stroke="currentColor" />
      <line x1="-130.78" y1="3.57087" x2="174.031" y2="-62.3628" stroke="currentColor" />
      <line x1="-130.118" y1="6.63386" x2="174.694" y2="-59.2998" stroke="currentColor" />
      <line x1="-129.456" y1="9.69685" x2="175.356" y2="-56.2368" stroke="currentColor" />
      <line x1="-128.793" y1="12.7598" x2="176.019" y2="-53.1738" stroke="currentColor" />
      <line x1="-128.13" y1="15.8228" x2="176.681" y2="-50.1108" stroke="currentColor" />
      <line x1="-127.468" y1="18.8858" x2="177.344" y2="-47.0479" stroke="currentColor" />
      <line x1="-126.805" y1="21.9488" x2="178.006" y2="-43.9849" stroke="currentColor" />
      <line x1="-126.143" y1="25.0118" x2="178.669" y2="-40.9219" stroke="currentColor" />
      <line x1="-125.48" y1="28.0743" x2="179.331" y2="-37.8594" stroke="currentColor" />
      <line x1="-124.817" y1="31.1373" x2="179.994" y2="-34.7964" stroke="currentColor" />
      <line x1="-124.155" y1="34.2003" x2="180.656" y2="-31.7334" stroke="currentColor" />
      <line x1="-123.493" y1="37.2633" x2="181.319" y2="-28.6704" stroke="currentColor" />
      <line x1="-122.83" y1="40.3262" x2="181.982" y2="-25.6074" stroke="currentColor" />
      <line x1="-122.167" y1="43.3892" x2="182.644" y2="-22.5444" stroke="currentColor" />
      <line x1="-121.505" y1="46.4522" x2="183.307" y2="-19.4814" stroke="currentColor" />
      <line x1="-120.842" y1="49.5147" x2="183.969" y2="-16.4189" stroke="currentColor" />
      <line x1="-120.18" y1="52.5777" x2="184.632" y2="-13.356" stroke="currentColor" />
      <line x1="-119.517" y1="55.6407" x2="185.295" y2="-10.293" stroke="currentColor" />
      <line x1="-118.855" y1="58.7037" x2="185.957" y2="-7.22998" stroke="currentColor" />
      <line x1="-118.192" y1="61.7667" x2="186.619" y2="-4.16699" stroke="currentColor" />
      <line x1="-117.529" y1="64.8297" x2="187.282" y2="-1.104" stroke="currentColor" />
      <line x1="-116.867" y1="67.8927" x2="187.944" y2="1.95899" stroke="currentColor" />
      <line x1="-116.205" y1="70.9556" x2="188.607" y2="5.02197" stroke="currentColor" />
      <line x1="-115.542" y1="74.0181" x2="189.27" y2="8.08447" stroke="currentColor" />
      <path d="M47 -37L267 31V-37H47Z" fill="currentColor" />
    </svg>
  );
}
